import { render, staticRenderFns } from "./LogSystem.vue?vue&type=template&id=6f4d91cb&"
import script from "./LogSystem.vue?vue&type=script&lang=js&"
export * from "./LogSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports